import React from 'react'
import Base from '../core/Base'

const UserDashBoard = () => {
    return (
        <Base title="User Dashboard">
            <h1>This is User Dashboard page</h1>
        </Base>        
    )
}

export default UserDashBoard
